// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__378JK","requiredAsterisk":"Info_requiredAsterisk__1CdAz"};